import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar/Navbar';
import Carousel from './components/Carousel/Carousel';
import AboutUs from './components/AboutUs/AboutUs';
import OurServices from './components/Services/Services';
import OurTeam1 from './components/OurTeam1/OurTeam1';
import WhyChooseUs from './components/WhyChooseUs/WhyChooseUs';
import IndustriesWeServe from './components/IndustriesWeServe/IndustriesWeServe';
import ContactUS from './components/ContactUs/ContactUs';
import Footer from './components/Footer/Footer';
import Form from './components/Form/Form';
import OurServicesDetail from './components/OurServicesDetail/OurServicesDetail';
import OurServicesDetail2 from './components/OurServicesDetail/OurServicesDetail2/OurServicesDetail2';
import OurServicesDetail3 from './components/OurServicesDetail/OurServicesDetail3/OurServicesDetail3';
import OurServicesDetail4 from './components/OurServicesDetail/OurServicesDetail4/OurServicesDetail4';
import OurServicesDetail5 from './components/OurServicesDetail/OurServicesDetail5/OurServicesDetail5';
import OurServicesDetail6 from './components/OurServicesDetail/OurServicesDetail6/OurServicesDetail6';
import OurServicesDetail7 from './components/OurServicesDetail/OurServicesDetail7/OurServicesDetail7';
import OurServicesDetail8 from './components/OurServicesDetail/OurServicesDetail8/OurServicesDetail8';
import Dashboard from './components/Dashboard/Dashboard';
import DCarousel from './components/Dashboard/Dpages/DCarousel';
import DAboutus from './components/Dashboard/Dpages/DAboutus';
import DOurservices from './components/Dashboard/Dpages/DOurservices';
import DOurteam from './components/Dashboard/Dpages/DOurteam';
import DWhychoose from './components/Dashboard/Dpages/DWhychoose';
// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Component Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Something went wrong loading this component.</h2>
          <details style={{ whiteSpace: 'pre-wrap', textAlign: 'left', margin: '10px 0' }}>
            {this.state.error && this.state.error.toString()}
          </details>
          <button onClick={() => this.setState({ hasError: false, error: null })}>
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Loading component
const LoadingSpinner = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '200px' 
  }}>
    <div>Loading...</div>
  </div>
);

// Home Page Component (combines all sections, but Footer is now handled globally)
const HomePage = () => (
  <Suspense fallback={<LoadingSpinner />}>
    <ErrorBoundary>
      <Carousel />
    </ErrorBoundary>
    <ErrorBoundary>
      <AboutUs />
    </ErrorBoundary>
    <ErrorBoundary>
      <OurServices />
    </ErrorBoundary>
    <br/>
    <br/>
    <ErrorBoundary>
      <OurTeam1 />
    </ErrorBoundary>
    <ErrorBoundary>
      <WhyChooseUs />
    </ErrorBoundary>
    <ErrorBoundary>
      <IndustriesWeServe />
    </ErrorBoundary>
    <ErrorBoundary>
      <ContactUS />
    </ErrorBoundary>
  </Suspense>
);

function App() {
  return (
    <BrowserRouter>
      <div>
        <ErrorBoundary>
          {/* Navbar displayed on all pages */}
          <Navbar />
        </ErrorBoundary>

        {/* Main Routes */}
        <Routes>
          {/* Home Page with all sections */}
          <Route path="/" element={<HomePage />} />
          
          {/* Individual Page Routes */}
          <Route path="/about" element={
            <ErrorBoundary>
              <AboutUs />
            </ErrorBoundary>
          } />
          
          <Route path="/services" element={
            <ErrorBoundary>
              <OurServices />
            </ErrorBoundary>
          } />
          
          <Route path="/team" element={
            <ErrorBoundary>
              <OurTeam1 />
            </ErrorBoundary>
          } />
          
          <Route path="/why-choose-us" element={
            <ErrorBoundary>
              <WhyChooseUs />
            </ErrorBoundary>
          } />
          
          <Route path="/industries" element={
            <ErrorBoundary>
              <IndustriesWeServe />
            </ErrorBoundary>
          } />

           <Route path="/contactus" element={
            <ErrorBoundary>
              <ContactUS />
            </ErrorBoundary>
          } />

             <Route path="/form" element={
            <ErrorBoundary>
              <Form />
            </ErrorBoundary>
          } />

             <Route path="/ourservicesdetail" element={
            <ErrorBoundary>
              <OurServicesDetail />
            </ErrorBoundary>
          } />

           <Route path="/ourservicesdetail2" element={
            <ErrorBoundary>
              <OurServicesDetail2 />
            </ErrorBoundary>
          } />

           <Route path="/ourservicesdetail3" element={
            <ErrorBoundary>
              <OurServicesDetail3 />
            </ErrorBoundary>
          } />

           <Route path="/ourservicesdetail4" element={
            <ErrorBoundary>
              <OurServicesDetail4 />
            </ErrorBoundary>
          } />

           <Route path="/ourservicesdetail5" element={
            <ErrorBoundary>
              <OurServicesDetail5 />
            </ErrorBoundary>
          } />

           <Route path="/ourservicesdetail6" element={
            <ErrorBoundary>
              <OurServicesDetail6 />
            </ErrorBoundary>
          } />

           <Route path="/ourservicesdetail7" element={
            <ErrorBoundary>
              <OurServicesDetail7 />
            </ErrorBoundary>
          } />

           <Route path="/ourservicesdetail8" element={
            <ErrorBoundary>
              <OurServicesDetail8 />
            </ErrorBoundary>
          } />

           <Route path="/dashboard" element={
            <ErrorBoundary>
              <Dashboard />
            </ErrorBoundary>
          } />

            <Route path="/DCarousel" element={
            <ErrorBoundary>
              <DCarousel />
            </ErrorBoundary>
          } />

           <Route path="/DAboutus" element={
            <ErrorBoundary>
              <DAboutus />
            </ErrorBoundary>
          } />

          <Route path="/DOurservices" element={
            <ErrorBoundary>
              <DOurservices />
            </ErrorBoundary>
          } />

          <Route path="/DOurteam" element={
            <ErrorBoundary>
              <DOurteam />
            </ErrorBoundary>
          } />

          <Route path="/DWhychoose" element={
            <ErrorBoundary>
              <DWhychoose />
            </ErrorBoundary>
          } />
          
          {/* 404 Not Found Route */}
          <Route path="*" element={
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <h1>404 - Page Not Found</h1>
              <p>The page you're looking for doesn't exist.</p>
            </div>
          } />
        </Routes>

        <ErrorBoundary>
          {/* Footer displayed on all pages */}
          <Footer />
        </ErrorBoundary>
      </div>
    </BrowserRouter>
  );
}

export default App;